import React  from 'react';

import { TextField, InputAdornment, IconButton } from "@mui/material";


import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle"


export interface TextFieldCenterProps {
  handleKeyDow?: (event : React.KeyboardEvent<HTMLInputElement>) => void,
  //onChange: (value: number) => void, // Add onChange to update the value
  //value: number,
  props : any
}

//const TextFieldCenter = ({ onChange, value, props } : any) => {
  const TextFieldCenter = ( props : any) => {

  // Handle Decrement
  // const handleDecrement = () => {
  //   //console.log("Decrement clicked", value);
  //   onChange(value - 1); // Call onChange to update the value
  // };

  // // Handle Increment
  // const handleIncrement = () => {
  //   //console.log("Increment clicked", value);
  //   onChange(value + 1); // Call onChange to update the value
  // };

    return(
      <TextField {...props} inputProps={{style: { textAlign: 'center' }}}
      // InputProps={{        
      //   startAdornment: (
      //     <InputAdornment position="start">
      //       <IconButton
      //         color="primary"
      //         onClick={handleDecrement}
      //          // Disable if no selection
      //          disabled={value <= 0}
      //       >
      //         <RemoveCircleIcon />
      //       </IconButton>
      //     </InputAdornment>
      //   ),
      //   endAdornment: (
      //     <InputAdornment position="end">
      //       <IconButton
      //         color="primary"
      //         onClick={handleIncrement}
              
      //       >
      //         <AddCircleIcon />
      //       </IconButton>
      //     </InputAdornment>
      //   ),
      // }}
      /> );
  }


export default TextFieldCenter;